export default "__VITE_ASSET__DtV$s5zv__"